module.exports = __webpack_public_path__ + "img/symbol_4.37d9a30d.png";